<template>
  <div id="app">
    <TheLayout>
      <router-view/>
    </TheLayout>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { FETCH_JOBS, FETCH_INSTAGRAM_RECENT_POST } from 'store/actions';
import TheLayout from 'components/TheLayout';

export default {
  name: 'App',
  components: {
    TheLayout,
  },
  created() {
    this.loadJobs();
    this.loadInstagramRecentPost();
  },
  methods: {
    ...mapActions({
      loadJobs: FETCH_JOBS,
      loadInstagramRecentPost: FETCH_INSTAGRAM_RECENT_POST,
    }),
  },
};
</script>

<style lang="scss">
@import 'styles/app';
</style>



// WEBPACK FOOTER //
// src/App.vue